<template>
    <section :id="`element-${settings.id}`" class="elle-path padd-v" :style="{ backgroundColor: settings?.color }">
        <UiHeadlineContent
            :settings="{
                label: settings?.label,
                headline: settings?.headline,
                content: settings?.body
            }"
        />
        <LoopsPath :items="settings?.pathItems" />
    </section>
</template>

<script setup lang="ts">
defineProps({
    settings: {
        type: Object,
        default: () => ({})
    }
});
</script>
